import LazyRoute from 'approot/shared/routes/lazy-route';
import {
  PRIVATE_CLASSES_PARAM,
  PRIVATE_MY_STUDENTS,
  PRIVATE_STUDENTS_IMPORT,
  PRIVATE_MY_STUDENTS_PORTFOLIO,
  PRIVATE_MY_STUDENTS_PORTFOLIO_DOWNLOAD_PDF,
  PRIVATE_MY_ASSIGNMENTS_PORTFOLIO_STUDENT_ANSWERS_DOWNLOAD_ZIP,
} from 'global/private-routes.constants';

const TeacherStudentRoutes = [
  {
    path: [
      PRIVATE_MY_STUDENTS,
      `${PRIVATE_CLASSES_PARAM}${PRIVATE_MY_STUDENTS}`,
    ],
    component: LazyRoute(
      () => import('approot/teacher-student/teacher-students'),
      true,
      false
    ),
  },
  {
    path: [
      `${PRIVATE_CLASSES_PARAM}${PRIVATE_STUDENTS_IMPORT}`,
      PRIVATE_STUDENTS_IMPORT,
    ],
    component: LazyRoute(
      () => import('approot/teacher-student/teacher-students-import'),
      true,
      false
    ),
  },
  {
    path: [
      `${PRIVATE_CLASSES_PARAM}${PRIVATE_MY_STUDENTS_PORTFOLIO}`,
      PRIVATE_MY_STUDENTS_PORTFOLIO,
    ],
    component: LazyRoute(
      () =>
        import('approot/teacher-student/portfolio/teacher-student-portfolio'),
      true,
      false
    ),
  },
  {
    path: [
      `${PRIVATE_CLASSES_PARAM}${PRIVATE_MY_STUDENTS_PORTFOLIO_DOWNLOAD_PDF}`,
      PRIVATE_MY_STUDENTS_PORTFOLIO_DOWNLOAD_PDF,
    ],
    component: LazyRoute(
      () =>
        import('approot/teacher-student/portfolio/download/teacher-student-portfolio-downloads'),
      true,
      false
    ),
  },
  {
    path: [
      `${PRIVATE_CLASSES_PARAM}${PRIVATE_MY_ASSIGNMENTS_PORTFOLIO_STUDENT_ANSWERS_DOWNLOAD_ZIP}`,
      PRIVATE_MY_ASSIGNMENTS_PORTFOLIO_STUDENT_ANSWERS_DOWNLOAD_ZIP,
    ],
    component: LazyRoute(
      () =>
        import('approot/teacher-student/portfolio/download/teacher-student-portfolio-download-student-answers'),
      true,
      false
    ),
  },
];

export default TeacherStudentRoutes;
